import { Box } from "@mui/material";
import { times } from "lodash";
import { CustomAccordionSkeleton } from "../../../components/CustomAccordianSkeletonShimmer/CustomAccordianSkeletonShimmer";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";
import { Colors } from "../../../styles/constant";

type AccordionBoxSkeletonProps = {
  showContainer?: boolean;
  showAddHoldingsSkeleton?: boolean;
};

const AccordionBoxSkeleton = ({
  showContainer = true,
  showAddHoldingsSkeleton = true,
}: AccordionBoxSkeletonProps) => {
  const content = (
    <>
      <Box
        display="flex"
        justifyContent="space-around"
        alignItems="center"
        marginBottom="1rem"
      >
        {times(3, (index) => (
          <CustomShimmer
            key={index}
            width="30%"
            height="1.5rem"
            borderRadius=".25rem"
          />
        ))}
      </Box>
      <Box display="flex" flexDirection="column" rowGap="0.5rem">
        {times(2, (index) => (
          <CustomAccordionSkeleton key={index} />
        ))}
      </Box>

      {showAddHoldingsSkeleton && (
        <Box display="flex" justifyContent="center" marginTop="1rem">
          <CustomShimmer width="40%" height="1rem" borderRadius=".25rem" />
        </Box>
      )}
    </>
  );

  if (!showContainer) {
    return content;
  }

  return (
    <Box
      sx={{ backgroundColor: Colors.bgGray }}
      padding="1rem .5rem"
      borderRadius=".75rem"
      marginTop={showAddHoldingsSkeleton ? "1rem" : "0rem"}
    >
      {content}
    </Box>
  );
};

export default AccordionBoxSkeleton;
